<template>
    <v-layout v-if="!isFetchingAccount && account">
        <v-flex>
            <v-card>
                <v-card-title>
                    <v-flex xs6>{{translater.__('Username', 'users')}}:</v-flex>
                    <v-flex xs6 v-if="!isEditingUsername">{{account.username}}</v-flex>
                    <v-flex xs6 v-else><v-text-field @input="changeUsername($event)" :value="account.username"></v-text-field></v-flex>
                </v-card-title>
                <v-card-actions>
                    <v-btn @click="isEditingUsername = true" v-if="!isEditingUsername"  flat color="primary">{{translater.__('Edit')}}</v-btn>
                    <div v-else>
                        <v-btn @click="isEditingUsername = false" flat color="warning">{{translater.__('Cancel')}}</v-btn>
                        <v-btn :disabled="!validUsername" @click="updateAccount()" flat color="success">{{translater.__('Save')}}</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
            <v-card>
                <v-card-title>
                    <v-flex xs6>{{translater.__('Password', 'users')}}:</v-flex>
                    <v-flex xs6 v-if="!isEditingPassword">*********</v-flex>
                    <v-flex xs6 v-else>
                        <v-flex xs12><v-text-field type="password"  value="" :placeholder="translater.__('New password')" @input="changePassword($event)"></v-text-field></v-flex>
                        <v-flex xs12>
                            <v-text-field type="password"  value="" :placeholder="translater.__('New password again')" @input="changePasswordConfirmation($event)"></v-text-field>
                            <span v-if="!validPassword" class="validationError">
                                {{translater
                                .__('Password cannot be empty and it has to match with the confirmation and must be at least {0} characters in length', 'UserValidaton', this.passwordMinLength)}}
                            </span>
                        </v-flex>

                    </v-flex>
                </v-card-title>
                <v-card-actions>
                    <v-btn @click="isEditingPassword = true" v-if="!isEditingPassword" flat color="primary">{{translater.__('Change')}}</v-btn>
                    <div v-else>
                        <v-btn @click="isEditingPassword = false" flat color="warning">{{translater.__('Cancel')}}</v-btn>
                        <v-btn :disabled="!validPassword" @click="updatePassword()" flat color="success">{{translater.__('Save')}}</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>

</template>
<script>
export default {
    name: 'UsersAccount',

    data()
    {
        return {
            mIsEditingUsername: false,
            mIsEditingPassword: false,
            newUsername: '',
            newPassword: '',
            passwordConfirmation: '',
            passwordMinLength: 6,
            validPassword: false

        }
    },

    methods: {
        updateAccount()
        {
            this.account.username = this.newUsername;
            this.newUsername = '';
            this.$store.dispatch('auth/updateAccount', {username: this.account.username})
                .then((res) => {
                    if(res.status === 200) { this.isEditingUsername = false; }
                }).catch((err) => {
                    console.log(err)
                })
        },

        updatePassword()
        {
            this.$store.dispatch('auth/updatePassword', {password: this.newPassword}).then(() => {
                this.isEditingPassword = false
            }).catch(err => {
                console.log(err)
            })
        },

        changePassword(e)
        {
            this.newPassword = e;
        },

        changeUsername(e){
          this.newUsername = e;
        },

        changePasswordConfirmation(e)
        {
            this.passwordConfirmation = e;
        },

        validate()
        {
            this.validPassword = this.newPassword.trim() !== ''
                    && this.newPassword.trim() === this.passwordConfirmation.trim()
                    && this.newPassword.trim().length >= this.passwordMinLength;
        }
    },

    watch: {
        password: {
            handler()
            {
                this.validate()
            }
        },

        passwordConfirmation: {
            handler()
            {
                this.validate();
            }
        }
    },

    computed: {
        translater: {
            get()
            {
                return this.$store.getters['translate/translater'];
            }
        },

        isFetchingAccount: {
            get()
            {
                let a = this.$store.getters['auth/isFetchingAccount']

                return a
            }
        },

        account: {
            get()
            {
                return this.$store.getters['auth/account']
            }

        },

        isEditingUsername: {
            get()
            {
                return this.mIsEditingUsername;
            },
            set(value)
            {
                if(!value){ this.newUsername = ''; }
                this.mIsEditingUsername = value;
            }
        },

        isEditingPassword: {
            get()
            {
                return this.mIsEditingPassword
            },

            set(value)
            {
                if(!value){
                    this.newPassword = '';
                    this.passwordConfirmation = '';
                }
                this.mIsEditingPassword = value;
            }
        },

        validUsername: {
            get()
            {
                return this.newUsername.trim() !== '';
            }
        },

      
    },

    mounted()
    {
        this.$store.dispatch('auth/account')
    }

};

</script>

<style scoped>
    .validationError{
        color: red;
        font-style: italic;
        font-size: small;
    }
</style>
